export default __webpack_public_path__ + "static/1. Student Management Made Easy 1-0f72cafffd825cb7431567bd0cb6689e.jpg";